// One store keeps the single-id field, which processes-api understood before ecommerce_ids.
export const toProcessEcommerceScope = (ecommerceIds?: string[]) =>
  ecommerceIds?.length === 1
    ? { ecommerce_id: ecommerceIds[0] }
    : { ecommerce_ids: ecommerceIds }
